var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 407,
    viewBox: "0 0 503 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.12207,
    width: 503,
    height: 406.228,
    rx: 8,
    fill: "#D2C7E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2348,
    y: 32.3568,
    width: 438.53,
    height: 92.9647,
    rx: 22.3021,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.469519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2871 43.86C35.2871 37.3773 40.5424 32.1221 47.0251 32.1221H456.445C462.928 32.1221 468.183 37.3773 468.183 43.86H35.2871Z",
    fill: "#351771"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9639,
    y: 58.415,
    width: 203.771,
    height: 20.1893,
    rx: 10.0947,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9639,
    y: 93.1592,
    width: 407.073,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2348,
    y: 133.791,
    width: 412.53,
    height: 115.927,
    rx: 22.3021,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 149.557,
    width: 349,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 177.557,
    width: 110.806,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 178.261,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.40856
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 200.355,
    width: 88.739,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 201.06,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#351771",
    strokeWidth: 1.40856
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8174,
    y: 203.173,
    width: 5.16471,
    height: 5.16471,
    rx: 2.58235,
    fill: "#351771"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 223.154,
    width: 144.612,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 223.859,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.40856
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2348,
    y: 133.791,
    width: 412.53,
    height: 115.927,
    rx: 22.3021,
    stroke: "#D9D9D9",
    strokeWidth: 0.469519
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2348,
    y: 258.188,
    width: 412.53,
    height: 115.927,
    rx: 22.3021,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 273.953,
    width: 349,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 301.953,
    width: 110.806,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 302.657,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.40856
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 324.752,
    width: 88.739,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 325.456,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#351771",
    strokeWidth: 1.40856
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8174,
    y: 327.569,
    width: 5.16471,
    height: 5.16471,
    rx: 2.58235,
    fill: "#351771"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 83.25,
    y: 347.551,
    width: 144.612,
    height: 10.7989,
    rx: 5.39947,
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7043,
    y: 348.255,
    width: 9.39037,
    height: 9.39037,
    rx: 4.69519,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.40856
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2348,
    y: 258.188,
    width: 412.53,
    height: 115.927,
    rx: 22.3021,
    stroke: "#D9D9D9",
    strokeWidth: 0.469519
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBanner);
export default __webpack_public_path__ + "static/media/hero-banner.d29de9a72f4d2f39bf8dad95f1d43692.svg";
export { ForwardRef as ReactComponent };